import { ISSOLoginConfig } from '../../contexts/ssoLoginContext';
import { IBaseAction } from '../useAction';
import useNavigation from '../useNavigation';
import { handleExternalSSORedirect } from '../../utils/handleExternalSSORedirect';

export interface ISSOLoginAction extends IBaseAction {
  type: 'sso_login';
  data: ISSOLoginConfig;
}

const useSSOLoginAction = () => {
  const navigation = useNavigation();

  const handleSSOLoginAction = (action: ISSOLoginAction) => {
    // If external SSO with ssoProviderUrl, redirect immediately without showing screen
    if (handleExternalSSORedirect(action.data)) {
      return;
    }

    // Otherwise, show the SSO login screen
    navigation.push({
      type: 'LOGIN',
      hideAppMenu: true,
      source: {
        loginMethod: 'SSO_LOGIN',
        ssoLoginConfig: action.data,
      },
    });
  };

  return handleSSOLoginAction;
};

export default useSSOLoginAction;
